import { Link } from 'react-router-dom';

const heroHighlights = [
  { icon: 'ri-layout-grid-line', text: '10 个频道' },
  { icon: 'ri-price-tag-3-line', text: '6 类专题' },
  { icon: 'ri-stack-line', text: '6 大内容板块' },
];

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[560px] md:min-h-[720px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Dramatic%20abstract%20dark%20editorial%20background%20with%20crimson%20and%20amber%20spotlight%20beams%20cutting%20through%20smoke%2C%20deep%20charcoal%20paper%20texture%2C%20layered%20geometric%20shapes%2C%20mystery%20and%20truth%20mood%2C%20cinematic%20lighting%2C%20no%20text&width=1600&height=900&seq=baoliao-hero-01&orientation=landscape)',
        }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/90" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 to-transparent" aria-hidden="true" />

      <div className="relative w-full px-4 md:px-8 pt-28 pb-16">
        <div className="max-w-4xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-300/40 bg-background-50/5 px-4 py-1.5 text-xs font-label tracking-[0.2em] uppercase text-accent-300 backdrop-blur">
            <i className="ri-radar-line" aria-hidden="true" />
            栏目 · 频道 · 专题 · 板块 全导航
          </span>

          <h1 className="mt-6 font-heading text-4xl md:text-6xl font-black leading-[1.15] text-background-50">
            爆料官网
            <span className="block mt-3 text-2xl md:text-4xl font-bold text-accent-400">
              栏目介绍与频道列表，一页看清全站结构
            </span>
          </h1>

          <p className="mt-6 max-w-2xl text-sm md:text-lg leading-relaxed text-background-200/90">
            我们把爆料内容拆成清晰的频道列表、专题分类与内容板块，用统一的导航栏把它们串起来。
            无论你想追踪热点、查阅深度调查，还是寻找可操作的维权指南，都能在这里快速定位。
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Link
              to="/channels"
              className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-label px-7 py-3.5 rounded-md transition-colors whitespace-nowrap"
            >
              <i className="ri-list-check-2" aria-hidden="true" />
              浏览频道列表
            </Link>
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 border border-background-50/35 hover:border-accent-300 hover:text-accent-300 text-background-50 font-label px-7 py-3.5 rounded-md transition-colors backdrop-blur-sm whitespace-nowrap"
            >
              <i className="ri-links-line" aria-hidden="true" />
              查看专题分类
            </Link>
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-4">
            {heroHighlights.map((item) => (
              <div key={item.text} className="flex items-center gap-2 text-sm text-background-100/85 font-label">
                <span className="w-8 h-8 rounded-md bg-background-50/10 flex items-center justify-center text-accent-300">
                  <i className={item.icon} aria-hidden="true" />
                </span>
                {item.text}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-accent-400/50 to-transparent" aria-hidden="true" />
    </section>
  );
}